import { render, staticRenderFns } from "./ReceiversList.vue?vue&type=template&id=f2d8a012&scoped=true&"
import script from "./ReceiversList.vue?vue&type=script&lang=js&"
export * from "./ReceiversList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiversList.vue?vue&type=style&index=0&id=f2d8a012&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d8a012",
  null
  
)

export default component.exports